import { useEffect, useState } from 'react';
import { request, SignIn, useAuth } from '../content/Auth';
export function ShareButton({ title }) {
  const [message, setMessage] = useState('');
  async function share() {
    try {
      if (navigator.share) await navigator.share({ title, url: window.location.href });
      else { await navigator.clipboard.writeText(window.location.href); setMessage('Link copied.'); }
    } catch (error) { if (error.name !== 'AbortError') setMessage('Copy the address from your browser to share this.'); }
  }
  return <div className="share"><button onClick={share}>Share</button><span role="status">{message}</span></div>;
}
export default function Discussion({ item }) {
  const { user, isAdmin } = useAuth();
  const [comments, setComments] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [body, setBody] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);
  const target = `${item.type}:${item.id}`;
  useEffect(() => {
    let active = true;
    setComments([]); setCursor(null); setError(''); setMessage(''); setBody(''); setLoading(true);
    request(`/api/comments?target=${encodeURIComponent(target)}`).then((result) => { if (active) { setComments(result.comments); setCursor(result.cursor); } }).catch((issue) => { if (active) setError(issue.message); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [target]);
  async function submit(event) {
    event.preventDefault(); setBusy(true); setMessage(''); setError('');
    try { const result = await request('/api/comments', { method: 'POST', body: JSON.stringify({ target, body }) }); setBody(''); setMessage(result.message); }
    catch (issue) { setError(issue.message); } finally { setBusy(false); }
  }
  async function more() {
    setBusy(true);
    try { const result = await request(`/api/comments?target=${encodeURIComponent(target)}&cursor=${encodeURIComponent(cursor)}`); setComments((previous) => [...previous, ...result.comments]); setCursor(result.cursor); }
    catch (issue) { setError(issue.message); } finally { setBusy(false); }
  }
  async function remove(id) {
    setBusy(true);
    try { await request('/api/comments', { method: 'PATCH', body: JSON.stringify({ action: 'remove', id, target }) }); setComments((previous) => previous.filter((comment) => comment.id !== id)); }
    catch (issue) { setError(issue.message); } finally { setBusy(false); }
  }
  return <section className="discussion"><h2>Leave a little noise</h2><p>Comments appear after approval. Keep it kind.</p><SignIn />{user && <form onSubmit={submit}><label htmlFor={`comment-${item.id}`}>Your comment</label><textarea id={`comment-${item.id}`} required maxLength={2000} rows={4} value={body} onChange={(event) => setBody(event.target.value)} /><button disabled={busy || !body.trim()}>Send for approval</button></form>}{message && <p role="status">{message}</p>}{error && <p role="alert">{error}</p>}{loading && <p role="status">Loading comments…</p>}{!loading && !error && comments.length === 0 && <p>No approved comments yet.</p>}{comments.map((comment) => <article className="comment" key={comment.id}><strong>{comment.author}</strong><time>{new Date(comment.createdAt).toLocaleDateString()}</time><p className="prose">{comment.body}</p>{isAdmin && <button disabled={busy} onClick={() => remove(comment.id)}>Remove comment</button>}</article>)}{cursor && <button disabled={busy} onClick={more}>More comments</button>}</section>;
}
